import { useTranslation } from 'react-i18next';
import Modal from '@lib/components/Modal/Modal';
import { IconName } from '@lib/components/Modal/enums';
import Typography from '@lib/components/Typography/Typography';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import Trans from '@lib/components/Trans/Trans';
import styles from './FtpHowItWorksModal.module.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function FtpHowItWorksModal({ isOpen, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('documents-import-ftp-modal-title')}
      icon={IconName.Help}
    >
      <>
        <div className={styles.section}>
          <Typography variant="body" strong block>
            {t('documents-import-ftp-modal-how-title')}
          </Typography>
          <ul className={styles.list}>
            <li>
              <Typography variant="body">
                {t('documents-import-ftp-modal-how-1')}
              </Typography>
            </li>
            <li>
              <Typography variant="body">
                {t('documents-import-ftp-modal-how-2')}
              </Typography>
            </li>
          </ul>
        </div>

        <div className={styles.section}>
          <Typography variant="body" strong block>
            {t('documents-import-ftp-modal-limitations-title')}
          </Typography>
          <ul className={styles.list}>
            <li>
              <Typography variant="body">
                {t('documents-import-ftp-modal-limitations-1')}
              </Typography>
            </li>
          </ul>
        </div>

        <div className={styles.section}>
          <Typography variant="body" strong block>
            {t('documents-import-ftp-modal-security-title')}
          </Typography>
          <ul className={styles.list}>
            <li>
              <Typography variant="body">
                {t('documents-import-ftp-modal-security-1')}
              </Typography>
            </li>
          </ul>
        </div>

        <SupportiveMessage
          color={SupportiveMessageColor.Blue}
          type={SupportiveMessageType.FilledWithLeftBorder}
          text={<Trans i18nKey="documents-import-ftp-modal-tip" />}
          fullWidth
        />
      </>
    </Modal>
  );
}
